<template>
  <div id="TransmisionEnVivo_div" class="w-100 px-5 py-4">
    <div id="TituloTransmisionEnVivo_div">
      <h1 style="margin-bottom: 0px;">PANEL DE AUDIENCIAS FINALIZADAS</h1>
      <h3 style="margin-top: 0px;">Búsqueda de audiencias finalizadas</h3>
    </div>
    <div class="row d-flex">
      <div id="BusquedaPanelDeAudienciasFinalizadas_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
        <div class="area">
          <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudienciasFinalizadas"></FiltrosDeBusqueda>
        </div>
      </div>
      <div id="ContenidoPanelDeAudienciasFinalizadas_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
        <div class="area">
          <h4>Audiencias encontradas</h4>
          <h6>Seleccione la audiencia a trabajar</h6>
          <hr />
          <div class="table-responsive">
            <table class="table table-striped table-light table-hover">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">Fecha y Hora</th>
                  <th class="text-center">Tipo de Documento</th>
                  <th class="text-center">Consecutivo</th>
                  <th class="text-center">Partido Judicial</th>
                  <th class="text-center">Juzgado</th>
                  <th class="text-center">Materia</th>
                  <th class="text-center">Tipo de Audiencia</th>
                  <th class="text-center">Sala</th>
                  <th class="text-center">Juez</th>
                  <th class="text-center">Operador</th>
                  <th class="text-center">Estatus</th>
                  <th class="text-center">Ver</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-for="audienciaFinalizada in audienciasFinalizadas">
                  <td v-html="obtenFechaDeAudienciaConFormato(audienciaFinalizada.FechaAudiencia)" style="width: 100px;"></td>
                  <td>{{audienciaFinalizada.TipoDocumento.Nombre}}</td>
                  <td class="text-center">{{audienciaFinalizada.Consecutivo}}</td>
                  <td class="text-center">{{audienciaFinalizada.PartidoJudicial.Nombre}}</td>
                  <td>{{audienciaFinalizada.Area.Nombre}}</td>
                  <td>{{audienciaFinalizada.Materia.Nombre}}</td>
                  <td class="text-center">{{audienciaFinalizada.TipoAudiencia.Nombre}}</td>
                  <td class="text-center">{{audienciaFinalizada.Sala.Nombre}}</td>
                  <td class="text-center" v-if="audienciaFinalizada.JuecesEnAudiencia.length === 0">SIN JUEZ</td>
                  <td class="text-center" v-if="audienciaFinalizada.JuecesEnAudiencia.length > 0"><p v-for="juez in audienciaPorVerificar.JuecesEnAudiencia">{{juez.Juez.Nombre}} {{juez.Juez.ApellidoPaterno}} {{juez.Juez.ApellidoMaterno}}</p></td>
                  <td>{{audienciaFinalizada.Usuario_OperadorDeSala.Nombre}}</td>
                  <td class="text-center">{{audienciaFinalizada.TipoEstatusDeAudiencia.Nombre}}</td>
                  <td class="text-center">
                    <router-link :to="{name: 'ReproducirAudiencia', params: { AudienciaId: audienciaFinalizada.AudienciaId } }">
                      <i class="fas fa-video" title="Ver vídeo"></i>
                    </router-link>
                  </td>
                  <td class="text-center">
                    <router-link :to="{ name: 'VistaDeInformacion', params: { AudienciaId: audienciaFinalizada.AudienciaId } }">
                      <i class="fas fa-search-plus" title="Ver detalles"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas'  
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Jueces, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        audienciasFinalizadas: []
      }
    },
    mounted() {
      //this.cargaAudienciasFinalizadas();
    },
    methods: {      
      obtenFechaDeAudienciaConFormato: function (fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      cargaAudienciasFinalizadas: function () {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          FechaInicial: this.$store.state.Comun_FechaInicial,
          FechaFinal: this.$store.state.Comun_FechaFinal,
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'],
          MateriaId: this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'],
          AreaId: this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'],
          SalaId: this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'],
          JuezId: this.$store.state.PJ_Catalogos_009PartidoJudicialId,
          EsPrueba: this.enumeraciones.EsPrueba
        }
        
        axios.post(
          api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.GetAudienciasFinalizadas,          
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => { 
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.audienciasFinalizadas = [];
          } else {
              if(respuesta.data.AudienciasFinalizadas.length>0)
              {
                this.audienciasFinalizadas = respuesta.data.AudienciasFinalizadas;
                this.$nextTick(()=> { PaginarTabla('ContenidoPanelDeAudienciasFinalizadas_div', 10)});
              }
              else
              {
                comun.mensajeDeAlerta("No se encontraron audiencias", null, null);
               this.audienciasFinalizadas = [];
              }

            //this.audienciasFinalizadas = respuesta.data.AudienciasFinalizadas;
          }

          comun.SeEstaCargandoInformacion(false);
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
          this.audienciasPendientes = [];
        });
      },
    }
  }  
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Consultas/PanelDeAudienciasFinalizadas/PanelDeAudienciasFinalizadas.vue